import { t } from "i18next";

export const pagesConfigurationSetup = [
//   {
//     tabName: "inicio",
//     tabIcon: null,
//     id: "home",
//     path: "/home",
//     filters: false,
//   },
  {
    tabName: "map",
    tabIcon: null,
    id: "map",
    path: "/map",
    filters: true,
  },
  {
    tabName: "registry",
    tabIcon: null,
    id: "registry",
    path: "/registry",
    filters: false,
  },
  {
    tabName: "events",
    tabIcon: null,
    id: "events",
    path: "/events",
    filters: false,
  },
  {
    tabName: "configurations",
    tabIcon: null,
    id: "configurations",
    path: "/configurations",
    filters: false,
  }
  // {
  //     tabName: "politicas",
  //     tabIcon: null,
  //     id: "policies",
  //     path: "/home/politics/CIRIS",
  //     subMenu: [{
  //         name: "Energia e Emissões",
  //         path: "/home/politics/CIRIS",
  //         submenus: null
  //     },
  //         // {
  //         //     name: "Certificado energético",
  //         //     path: "/home/politics/energeticCertficate",
  //         //     submenus: null
  //         // }
  //     ],
  //     filters: false
  // }
];

export function months (t) {
    return [
        { value: 1, label: t("January") },
        { value: 2, label: t("February") },
        { value: 3, label: t("March") },
        { value: 4, label: t("April") },
        { value: 5, label: t("May") },
        { value: 6, label: t("June") },
        { value: 7, label: t("July") },
        { value: 8, label: t("August") },
        { value: 9, label: t("September") },
        { value: 10, label: t("October") },
        { value: 11, label: t("November") },
        { value: 12, label: t("December") },
    ];
} 
export const years = [
  { value: 2022, label: "2022" },
  { value: 2023, label: "2023" },
  { value: 2024, label: "2024" },
];
export const fullMetrics = [
  { value: "occupation", label: t("Occupation")},
  { value: 'humidity', label: t("Humidity") },
  { value: 'luminosity', label: t("Lighting") },
  { value: 'airQuality', label: t("Air Quality") },
  { value: 'soundLevel', label: t("Noise") },
  { value: 'temperature', label: t("Temperature") },
];
export const metrics = [ //took off occupation to prevent an error
    { value: 'humidity', label: "Humidity" },
    { value: 'luminosity', label: "Lighting" },
    { value: 'airQuality', label: "Air Quality" },
    { value: 'soundLevel', label: "Noise" },
    { value: 'temperature', label: "Temperature" },
  ];
  

export const eventsDataDonut = {
    id: 11,
    cols: 8,
    height: '156px',
    width: 'auto',
    background: 'neutral-1',
    title: t('Events Severity'),
    icon: 'Alert',
    background: 'white',
    description: null,
    tooltip: null,
    charts: [

        {
            chartType: 'bigNumberChart',
            height: '60px',
            width: '100%',
            data:{number:10}
        },
        {
            chartType: 'horizontalStackedBarChart',
            height: '27px',
            width: '100%',
            chartId: 'horizontalStackedBarChartOne',
            data:[
                {
                  name: "A",
                  values: [
                    {
                      name: t("Critical"),
                      value: 1,
                    },
                    {
                      name: t("High"),
                      value: 0,
                    },
                    {
                      name: t("Medium"),
                      value: 0,
                    },
                    {
                      name: t("Low"),
                      value: 3,
                    },
                    {
                      name: t("Info"),
                      value: 3,
                    },
                  ],
                },
              ]
        }
    ]
}

export const eventsDataBignumbers = [
    {
        id: 11,
        cols: 7,
        height: '156px',
        width: 'auto',
        background: 'white',
        title: 'Critical',
        icon: '',
        iconColor: 'critical-base',
        description: null,
        tooltip: null,
        charts: [
            {
                chartType: 'bigNumberChart',
                height: '87px',
                chartId: 'bigNumberChartOne',
                data: {number: 0}
            }
        ],
    },
    {
        id: 12,
        cols: 7,
        height: '156px',
        width: 'auto',
        background: 'white',
        title: 'High',
        icon: '',
        iconColor: 'high-base',
        description: null,
        tooltip: null,
        charts: [
            {
                chartType: 'bigNumberChart',
                height: '87px',
                data: {number: 0}
            }
        ],
    },
    {
        id: 13,
        cols: 10,
        height: '156px',
        width: '100%',
        background: 'white',
        title: 'Others',
        icon: null,
        iconColor: null,
        description: null,
        tooltip: null,
        charts: [
            {
                chartType: 'dataChart',
                height: '87px',
                data: [
                    {
                        circleColor: "medium-base",
                        unit: t("Medium"),
                        number: 0,
                    },
                    {
                        circleColor: "low-base",
                        unit: t("Low"),
                        number:0,
                    },
                    {
                        circleColor: "info-base",
                        unit: t("Info"),
                        number: 3,
                    },
                  ]
            }
        ],
    },
    // {
    //     id: 14,
    //     cols: 8,
    //     height: '194px',
    //     width: 'auto',
    //     background: 'white',
    //     title: 'Baixo',
    //     icon: '',
    //     iconColor: 'low-base',
    //     description: null,
    //     tooltip: null,
    //     charts: [
    //         {
    //             chartType: 'bigNumberChart',
    //             height: '87px',
    //             chartId: 'bigNumberChartOne',
    //             chartQuery: '/unified_temporary/events/low',
    //             idQuery: 'getLow'
    //         }
    //     ],
    // },
    // {
    //     id: 15,
    //     cols: 8,
    //     height: '194px',
    //     width: 'auto',
    //     background: 'white',
    //     title: 'Info',
    //     icon: '',
    //     iconColor: 'info-base',
    //     description: null,
    //     tooltip: null,
    //     charts: [
    //         {
    //             chartType: 'bigNumberChart',
    //             height: '87px',
    //             chartId: 'bigNumberChartOne',
    //             chartQuery: '/unified_temporary/events/info',
    //             idQuery: 'getInfo'
    //         }
    //     ],
    // },
]

export const eventsData = [
    {
        id: 'map',
        cols: 24,
        height: '603px',
        width: 'auto',
        background: null,
        border: 'neutral-3',
        title: 'Events Map',
        icon: 'Clipboard',
        description: null,
        tooltip: null,
        charts: null,
        map: {
            type: 'mapEvents',
            idQuery: null
        },
        // switch: 'seeInfoEvents',
    },
    // {
    //     id: 'alertofconsume',
    //     cols: 24,
    //     height: '447px',
    //     width: 'auto',
    //     background: null,
    //     title: 'Alerts distribution',
    //     icon: 'Clipboard',
    //     description: null,
    //     tooltip: null,
    //     charts: [
    //         {
    //             cols: 18,
    //             chartType: 'mixBarChartLine',
    //             height: '100%',
    //             width: '100%',
    //             chartQuery: '/unified_temporary/events/getAlertsInLastMonth',
    //             idQuery: 'getAlertsInLastMonth',
    //             chartId: 'mixBarChartLineTwo'
    //         },
    //         {
    //             cols: 6,
    //             chartType: 'dataChart',
    //             height: '100%',
    //             width: '100%',
    //             chartId: 'dataChartTwo',
    //             chartQuery: '/unified_temporary/events/totalAlerts',
    //             idQuery: 'getTotalAlerts',
    //         }
    //     ]
    // },
    {
        id: "consumelevel",
        cols: 24,
        height: '447px',
        width: 'auto',
        background: null,
        border: 'neutral-3',
        title: 'Event Density',
        icon: 'Clipboard',
        description: null,
        tooltip: null,
        charts: [
            {
                chartType: 'heatmapChart',
                height: '603px ',
                width: '100%',
                chartId: 'heatmapChartOne',
                data:{
                    series: [
                      {
                        name: "Jan",
                        data: generateData(30, { min: 0, max: 40 }),
                      },
                      {
                        name: "Fev",
                        data: generateData(30, { min: 0, max: 40 }),
                      },
                      {
                        name: "Mar",
                        data: generateData(30, { min: 0, max: 40 }),
                      },
                      {
                        name: "Abr",
                        data: generateData(30, { min: 0, max: 40 }),
                      },
                      {
                        name: "Mai",
                        data: generateData(30, { min: 0, max: 40 }),
                      },
                      {
                        name: "Jun",
                        data: generateData(30, { min: 0, max: 40 }),
                      },
                      {
                        name: "Jul",
                        data: generateData(30, { min: 0, max: 40 }),
                      },
                      {
                        name: "Ago",
                        data: generateData(30, { min: 0, max: 40 }),
                      },
                      {
                        name: "Set",
                        data: generateData(30, { min: 0, max: 40 }),
                      },
                      {
                        name: "Out",
                        data: generateData(30, { min: 0, max: 40 }),
                      },
                      {
                        name: "Nov",
                        data: generateData(30, { min: 0, max: 40 }),
                      },
                      {
                        name: "Dez",
                        data: generateData(30, { min: 0, max: 40 }),
                      },
                    ]
                }
            }
        ]
    },

]

export function loaddiagramDummyData(t){
    return {
        "series": [
            {
                "name": t("Active raw power"),
                "type": "line",
                "data": [
                    {
                        "x": "0h0",
                        "y": 1
                    },
                    {
                        "x": "0h15",
                        "y": 2
                    },
                    {
                        "x": "0h30",
                        "y": 2
                    },
                    {
                        "x": "0h45",
                        "y": 1
                    },
                    {
                        "x": "1h0",
                        "y": 1
                    },
                    {
                        "x": "1h15",
                        "y": 1
                    },
                    {
                        "x": "1h30",
                        "y": 1
                    },
                    {
                        "x": "1h45",
                        "y": 1
                    },
                    {
                        "x": "2h0",
                        "y": 2
                    },
                    {
                        "x": "2h15",
                        "y": 1
                    },
                    {
                        "x": "2h30",
                        "y": 2
                    },
                    {
                        "x": "2h45",
                        "y": 3
                    },
                    {
                        "x": "3h0",
                        "y": 1
                    },
                    {
                        "x": "3h15",
                        "y": 2
                    },
                    {
                        "x": "3h30",
                        "y": 1
                    },
                    {
                        "x": "3h45",
                        "y": 1
                    },
                    {
                        "x": "4h0",
                        "y": 1
                    },
                    {
                        "x": "4h15",
                        "y": 2
                    },
                    {
                        "x": "4h30",
                        "y": 1
                    },
                    {
                        "x": "4h45",
                        "y": 1
                    },
                    {
                        "x": "5h0",
                        "y": 1
                    },
                    {
                        "x": "5h15",
                        "y": 1
                    },
                    {
                        "x": "5h30",
                        "y": 1
                    },
                    {
                        "x": "5h45",
                        "y": 2
                    },
                    {
                        "x": "6h0",
                        "y": 1
                    },
                    {
                        "x": "6h15",
                        "y": 0
                    },
                    {
                        "x": "6h30",
                        "y": 2
                    },
                    {
                        "x": "6h45",
                        "y": 1
                    },
                    {
                        "x": "7h0",
                        "y": 1
                    },
                    {
                        "x": "7h15",
                        "y": 0
                    },
                    {
                        "x": "7h30",
                        "y": 2
                    },
                    {
                        "x": "7h45",
                        "y": 4
                    },
                    {
                        "x": "8h0",
                        "y": 3
                    },
                    {
                        "x": "8h15",
                        "y": 4
                    },
                    {
                        "x": "8h30",
                        "y": 4
                    },
                    {
                        "x": "8h45",
                        "y": 4
                    },
                    {
                        "x": "9h0",
                        "y": 5
                    },
                    {
                        "x": "9h15",
                        "y": 6
                    },
                    {
                        "x": "9h30",
                        "y": 6
                    },
                    {
                        "x": "9h45",
                        "y": 7
                    },
                    {
                        "x": "10h0",
                        "y": 7
                    },
                    {
                        "x": "10h15",
                        "y": 9
                    },
                    {
                        "x": "10h30",
                        "y": 6
                    },
                    {
                        "x": "10h45",
                        "y": 8
                    },
                    {
                        "x": "11h0",
                        "y": 7
                    },
                    {
                        "x": "11h15",
                        "y": 4
                    },
                    {
                        "x": "11h30",
                        "y": 3
                    },
                    {
                        "x": "11h45",
                        "y": 2
                    },
                    {
                        "x": "12h0",
                        "y": 2
                    },
                    {
                        "x": "12h15",
                        "y": 3
                    },
                    {
                        "x": "12h30",
                        "y": 6
                    },
                    {
                        "x": "12h45",
                        "y": 5
                    },
                    {
                        "x": "13h0",
                        "y": 4
                    },
                    {
                        "x": "13h15",
                        "y": 3
                    },
                    {
                        "x": "13h30",
                        "y": 4
                    },
                    {
                        "x": "13h45",
                        "y": 6
                    },
                    {
                        "x": "14h0",
                        "y": 5
                    },
                    {
                        "x": "14h15",
                        "y": 3
                    },
                    {
                        "x": "14h30",
                        "y": 4
                    },
                    {
                        "x": "14h45",
                        "y": 5
                    },
                    {
                        "x": "15h0",
                        "y": 6
                    },
                    {
                        "x": "15h15",
                        "y": 4
                    },
                    {
                        "x": "15h30",
                        "y": 5
                    },
                    {
                        "x": "15h45",
                        "y": 4
                    },
                    {
                        "x": "16h0",
                        "y": 6
                    },
                    {
                        "x": "16h15",
                        "y": 5
                    },
                    {
                        "x": "16h30",
                        "y": 5
                    },
                    {
                        "x": "16h45",
                        "y": 6
                    },
                    {
                        "x": "17h0",
                        "y": 5
                    },
                    {
                        "x": "17h15",
                        "y": 5
                    },
                    {
                        "x": "17h30",
                        "y": 6
                    },
                    {
                        "x": "17h45",
                        "y": 4
                    },
                    {
                        "x": "18h0",
                        "y": 4
                    },
                    {
                        "x": "18h15",
                        "y": 2
                    },
                    {
                        "x": "18h30",
                        "y": 1
                    },
                    {
                        "x": "18h45",
                        "y": 1
                    },
                    {
                        "x": "19h0",
                        "y": 1
                    },
                    {
                        "x": "19h15",
                        "y": 2
                    },
                    {
                        "x": "19h30",
                        "y": 1
                    },
                    {
                        "x": "19h45",
                        "y": 1
                    },
                    {
                        "x": "20h0",
                        "y": 1
                    },
                    {
                        "x": "20h15",
                        "y": 2
                    },
                    {
                        "x": "20h30",
                        "y": 1
                    },
                    {
                        "x": "20h45",
                        "y": 1
                    },
                    {
                        "x": "21h0",
                        "y": 2
                    },
                    {
                        "x": "21h15",
                        "y": 1
                    },
                    {
                        "x": "21h30",
                        "y": 1
                    },
                    {
                        "x": "21h45",
                        "y": 1
                    },
                    {
                        "x": "22h0",
                        "y": 1
                    },
                    {
                        "x": "22h15",
                        "y": 1
                    },
                    {
                        "x": "22h30",
                        "y": 1
                    },
                    {
                        "x": "22h45",
                        "y": 2
                    },
                    {
                        "x": "23h0",
                        "y": 1
                    },
                    {
                        "x": "23h15",
                        "y": 1
                    },
                    {
                        "x": "23h30",
                        "y": 2
                    },
                    {
                        "x": "23h45",
                        "y": 2
                    }
                ]
            },
            {
                "name": t("Contracted Power"),
                "type": "line",
                "data": [
                    {
                        "x": "0h0",
                        "y": 40
                    },
                    {
                        "x": "0h15",
                        "y": 40
                    },
                    {
                        "x": "0h30",
                        "y": 40
                    },
                    {
                        "x": "0h45",
                        "y": 40
                    },
                    {
                        "x": "1h0",
                        "y": 40
                    },
                    {
                        "x": "1h15",
                        "y": 40
                    },
                    {
                        "x": "1h30",
                        "y": 40
                    },
                    {
                        "x": "1h45",
                        "y": 40
                    },
                    {
                        "x": "2h0",
                        "y": 40
                    },
                    {
                        "x": "2h15",
                        "y": 40
                    },
                    {
                        "x": "2h30",
                        "y": 40
                    },
                    {
                        "x": "2h45",
                        "y": 40
                    },
                    {
                        "x": "3h0",
                        "y": 40
                    },
                    {
                        "x": "3h15",
                        "y": 40
                    },
                    {
                        "x": "3h30",
                        "y": 40
                    },
                    {
                        "x": "3h45",
                        "y": 40
                    },
                    {
                        "x": "4h0",
                        "y": 40
                    },
                    {
                        "x": "4h15",
                        "y": 40
                    },
                    {
                        "x": "4h30",
                        "y": 40
                    },
                    {
                        "x": "4h45",
                        "y": 40
                    },
                    {
                        "x": "5h0",
                        "y": 40
                    },
                    {
                        "x": "5h15",
                        "y": 40
                    },
                    {
                        "x": "5h30",
                        "y": 40
                    },
                    {
                        "x": "5h45",
                        "y": 40
                    },
                    {
                        "x": "6h0",
                        "y": 40
                    },
                    {
                        "x": "6h15",
                        "y": 40
                    },
                    {
                        "x": "6h30",
                        "y": 40
                    },
                    {
                        "x": "6h45",
                        "y": 40
                    },
                    {
                        "x": "7h0",
                        "y": 40
                    },
                    {
                        "x": "7h15",
                        "y": 40
                    },
                    {
                        "x": "7h30",
                        "y": 40
                    },
                    {
                        "x": "7h45",
                        "y": 40
                    },
                    {
                        "x": "8h0",
                        "y": 40
                    },
                    {
                        "x": "8h15",
                        "y": 40
                    },
                    {
                        "x": "8h30",
                        "y": 40
                    },
                    {
                        "x": "8h45",
                        "y": 40
                    },
                    {
                        "x": "9h0",
                        "y": 40
                    },
                    {
                        "x": "9h15",
                        "y": 40
                    },
                    {
                        "x": "9h30",
                        "y": 40
                    },
                    {
                        "x": "9h45",
                        "y": 40
                    },
                    {
                        "x": "10h0",
                        "y": 40
                    },
                    {
                        "x": "10h15",
                        "y": 40
                    },
                    {
                        "x": "10h30",
                        "y": 40
                    },
                    {
                        "x": "10h45",
                        "y": 40
                    },
                    {
                        "x": "11h0",
                        "y": 40
                    },
                    {
                        "x": "11h15",
                        "y": 40
                    },
                    {
                        "x": "11h30",
                        "y": 40
                    },
                    {
                        "x": "11h45",
                        "y": 40
                    },
                    {
                        "x": "12h0",
                        "y": 40
                    },
                    {
                        "x": "12h15",
                        "y": 40
                    },
                    {
                        "x": "12h30",
                        "y": 40
                    },
                    {
                        "x": "12h45",
                        "y": 40
                    },
                    {
                        "x": "13h0",
                        "y": 40
                    },
                    {
                        "x": "13h15",
                        "y": 40
                    },
                    {
                        "x": "13h30",
                        "y": 40
                    },
                    {
                        "x": "13h45",
                        "y": 40
                    },
                    {
                        "x": "14h0",
                        "y": 40
                    },
                    {
                        "x": "14h15",
                        "y": 40
                    },
                    {
                        "x": "14h30",
                        "y": 40
                    },
                    {
                        "x": "14h45",
                        "y": 40
                    },
                    {
                        "x": "15h0",
                        "y": 40
                    },
                    {
                        "x": "15h15",
                        "y": 40
                    },
                    {
                        "x": "15h30",
                        "y": 40
                    },
                    {
                        "x": "15h45",
                        "y": 40
                    },
                    {
                        "x": "16h0",
                        "y": 40
                    },
                    {
                        "x": "16h15",
                        "y": 40
                    },
                    {
                        "x": "16h30",
                        "y": 40
                    },
                    {
                        "x": "16h45",
                        "y": 40
                    },
                    {
                        "x": "17h0",
                        "y": 40
                    },
                    {
                        "x": "17h15",
                        "y": 40
                    },
                    {
                        "x": "17h30",
                        "y": 40
                    },
                    {
                        "x": "17h45",
                        "y": 40
                    },
                    {
                        "x": "18h0",
                        "y": 40
                    },
                    {
                        "x": "18h15",
                        "y": 40
                    },
                    {
                        "x": "18h30",
                        "y": 40
                    },
                    {
                        "x": "18h45",
                        "y": 40
                    },
                    {
                        "x": "19h0",
                        "y": 40
                    },
                    {
                        "x": "19h15",
                        "y": 40
                    },
                    {
                        "x": "19h30",
                        "y": 40
                    },
                    {
                        "x": "19h45",
                        "y": 40
                    },
                    {
                        "x": "20h0",
                        "y": 40
                    },
                    {
                        "x": "20h15",
                        "y": 40
                    },
                    {
                        "x": "20h30",
                        "y": 40
                    },
                    {
                        "x": "20h45",
                        "y": 40
                    },
                    {
                        "x": "21h0",
                        "y": 40
                    },
                    {
                        "x": "21h15",
                        "y": 40
                    },
                    {
                        "x": "21h30",
                        "y": 40
                    },
                    {
                        "x": "21h45",
                        "y": 40
                    },
                    {
                        "x": "22h0",
                        "y": 40
                    },
                    {
                        "x": "22h15",
                        "y": 40
                    },
                    {
                        "x": "22h30",
                        "y": 40
                    },
                    {
                        "x": "22h45",
                        "y": 40
                    },
                    {
                        "x": "23h0",
                        "y": 40
                    },
                    {
                        "x": "23h15",
                        "y": 40
                    },
                    {
                        "x": "23h30",
                        "y": 40
                    },
                    {
                        "x": "23h45",
                        "y": 40
                    }
                ]
            },
            {
                "name": t("Maximum power allowed"),
                "type": "line",
                "data": [
                    {
                        "x": "0h0",
                        "y": 42
                    },
                    {
                        "x": "0h15",
                        "y": 42
                    },
                    {
                        "x": "0h30",
                        "y": 42
                    },
                    {
                        "x": "0h45",
                        "y": 42
                    },
                    {
                        "x": "1h0",
                        "y": 42
                    },
                    {
                        "x": "1h15",
                        "y": 42
                    },
                    {
                        "x": "1h30",
                        "y": 42
                    },
                    {
                        "x": "1h45",
                        "y": 42
                    },
                    {
                        "x": "2h0",
                        "y": 42
                    },
                    {
                        "x": "2h15",
                        "y": 42
                    },
                    {
                        "x": "2h30",
                        "y": 42
                    },
                    {
                        "x": "2h45",
                        "y": 42
                    },
                    {
                        "x": "3h0",
                        "y": 42
                    },
                    {
                        "x": "3h15",
                        "y": 42
                    },
                    {
                        "x": "3h30",
                        "y": 42
                    },
                    {
                        "x": "3h45",
                        "y": 42
                    },
                    {
                        "x": "4h0",
                        "y": 42
                    },
                    {
                        "x": "4h15",
                        "y": 42
                    },
                    {
                        "x": "4h30",
                        "y": 42
                    },
                    {
                        "x": "4h45",
                        "y": 42
                    },
                    {
                        "x": "5h0",
                        "y": 42
                    },
                    {
                        "x": "5h15",
                        "y": 42
                    },
                    {
                        "x": "5h30",
                        "y": 42
                    },
                    {
                        "x": "5h45",
                        "y": 42
                    },
                    {
                        "x": "6h0",
                        "y": 42
                    },
                    {
                        "x": "6h15",
                        "y": 42
                    },
                    {
                        "x": "6h30",
                        "y": 42
                    },
                    {
                        "x": "6h45",
                        "y": 42
                    },
                    {
                        "x": "7h0",
                        "y": 42
                    },
                    {
                        "x": "7h15",
                        "y": 42
                    },
                    {
                        "x": "7h30",
                        "y": 42
                    },
                    {
                        "x": "7h45",
                        "y": 42
                    },
                    {
                        "x": "8h0",
                        "y": 42
                    },
                    {
                        "x": "8h15",
                        "y": 42
                    },
                    {
                        "x": "8h30",
                        "y": 42
                    },
                    {
                        "x": "8h45",
                        "y": 42
                    },
                    {
                        "x": "9h0",
                        "y": 42
                    },
                    {
                        "x": "9h15",
                        "y": 42
                    },
                    {
                        "x": "9h30",
                        "y": 42
                    },
                    {
                        "x": "9h45",
                        "y": 42
                    },
                    {
                        "x": "10h0",
                        "y": 42
                    },
                    {
                        "x": "10h15",
                        "y": 42
                    },
                    {
                        "x": "10h30",
                        "y": 42
                    },
                    {
                        "x": "10h45",
                        "y": 42
                    },
                    {
                        "x": "11h0",
                        "y": 42
                    },
                    {
                        "x": "11h15",
                        "y": 42
                    },
                    {
                        "x": "11h30",
                        "y": 42
                    },
                    {
                        "x": "11h45",
                        "y": 42
                    },
                    {
                        "x": "12h0",
                        "y": 42
                    },
                    {
                        "x": "12h15",
                        "y": 42
                    },
                    {
                        "x": "12h30",
                        "y": 42
                    },
                    {
                        "x": "12h45",
                        "y": 42
                    },
                    {
                        "x": "13h0",
                        "y": 42
                    },
                    {
                        "x": "13h15",
                        "y": 42
                    },
                    {
                        "x": "13h30",
                        "y": 42
                    },
                    {
                        "x": "13h45",
                        "y": 42
                    },
                    {
                        "x": "14h0",
                        "y": 42
                    },
                    {
                        "x": "14h15",
                        "y": 42
                    },
                    {
                        "x": "14h30",
                        "y": 42
                    },
                    {
                        "x": "14h45",
                        "y": 42
                    },
                    {
                        "x": "15h0",
                        "y": 42
                    },
                    {
                        "x": "15h15",
                        "y": 42
                    },
                    {
                        "x": "15h30",
                        "y": 42
                    },
                    {
                        "x": "15h45",
                        "y": 42
                    },
                    {
                        "x": "16h0",
                        "y": 42
                    },
                    {
                        "x": "16h15",
                        "y": 42
                    },
                    {
                        "x": "16h30",
                        "y": 42
                    },
                    {
                        "x": "16h45",
                        "y": 42
                    },
                    {
                        "x": "17h0",
                        "y": 42
                    },
                    {
                        "x": "17h15",
                        "y": 42
                    },
                    {
                        "x": "17h30",
                        "y": 42
                    },
                    {
                        "x": "17h45",
                        "y": 42
                    },
                    {
                        "x": "18h0",
                        "y": 42
                    },
                    {
                        "x": "18h15",
                        "y": 42
                    },
                    {
                        "x": "18h30",
                        "y": 42
                    },
                    {
                        "x": "18h45",
                        "y": 42
                    },
                    {
                        "x": "19h0",
                        "y": 42
                    },
                    {
                        "x": "19h15",
                        "y": 42
                    },
                    {
                        "x": "19h30",
                        "y": 42
                    },
                    {
                        "x": "19h45",
                        "y": 42
                    },
                    {
                        "x": "20h0",
                        "y": 42
                    },
                    {
                        "x": "20h15",
                        "y": 42
                    },
                    {
                        "x": "20h30",
                        "y": 42
                    },
                    {
                        "x": "20h45",
                        "y": 42
                    },
                    {
                        "x": "21h0",
                        "y": 42
                    },
                    {
                        "x": "21h15",
                        "y": 42
                    },
                    {
                        "x": "21h30",
                        "y": 42
                    },
                    {
                        "x": "21h45",
                        "y": 42
                    },
                    {
                        "x": "22h0",
                        "y": 42
                    },
                    {
                        "x": "22h15",
                        "y": 42
                    },
                    {
                        "x": "22h30",
                        "y": 42
                    },
                    {
                        "x": "22h45",
                        "y": 42
                    },
                    {
                        "x": "23h0",
                        "y": 42
                    },
                    {
                        "x": "23h15",
                        "y": 42
                    },
                    {
                        "x": "23h30",
                        "y": 42
                    },
                    {
                        "x": "23h45",
                        "y": 42
                    }
                ]
            }
        ],
        "categories": [],
        "xAxisType": null,
        "labelFormat": "Monthly",
        "tooltip": null,
        "unit": "kW",
        "columnWidth": 20,
        "xAxisLabel": null,
        "yAxisLabel": "kW",
        "color": null,
        "tickAmount": 24,
        "formatterType": "Monthly",
        "filename": "Gráfico exportado",
        "headerValue": "valores",
        "headerCategory": "categorias",
        "showTooltipTitle": true
      }
}

export const hugo = {//Para remover
    "series": [
        {
            "name": "Valores Médios",
            "type": "column",
            "data": [
                {
                    "x": "05:00",
                    "y": 21
                },
                {
                    "x": "06:00",
                    "y": 24
                },
                {
                    "x": "07:00",
                    "y": 25
                },
                {
                    "x": "08:00",
                    "y": 22
                }
            ]
        },
        {
            "name": "Valor Minimo Admissível",
            "type": "line",
            "data": [{
                "x": "05:00",
                "y": 20
            },
            {
                "x": "06:00",
                "y": 20
            },
            {
                "x": "07:00",
                "y": 20
            },
            {
                "x": "08:00",
                "y": 20
            }]
        },
        {
            "name": "Valor Máxima Admissível",
            "type": "line",
            "data": [{
                "x": "05:00",
                "y": 30
            },
            {
                "x": "030:00",
                "y": 30
            },
            {
                "x": "07:00",
                "y": 30
            },
            {
                "x": "08:00",
                "y": 30
            }]
        },
        {
            "name": "Valor Minimo de Cada Hora",
            "type": "scatter",
            "data": [{
                "x": "05:00",
                "y": 19
            },
            {
                "x": "030:00",
                "y": 21
            },
            {
                "x": "07:00",
                "y": 22
            },
            {
                "x": "08:00",
                "y": 20
            }]
        },
        {
            "name": "Valor Máximo de Cada Hora",
            "type": "scatter",
            "data": [{
                "x": "05:00",
                "y": 23
            },
            {
                "x": "030:00",
                "y": 25
            },
            {
                "x": "07:00",
                "y": 25
            },
            {
                "x": "08:00",
                "y": 23
            }]
        }
    ],
    "categories": [],
    "xAxisType": null,
    "labelFormat": "Monthly",
    "tooltip": null,
    "unit": "ºC",
    "columnWidth": 2,
    "xAxisLabel": null,
    "yAxisLabel": "ºC",
    "color": null,
    "tickAmount": 24,
    "formatterType": "Monthly",
    "filename": "Gráfico exportado",
    "headerValue": "valores",
    "headerCategory": "categorias",
    "showTooltipTitle": true
  }

function generateData(count, yrange) {
    var i = 0;
    var series = [];

    while (i < count) {
    var x = (i + 1).toString();
    var y =
        Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min;

    series.push({
        x: x,
        y: y,
    });
    i++;
    }

    return series;
}
  